// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eH9k","rootNoMargin":"styles_rootNoMargin__1IvVf"};